import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import {
  RouteParamsTypes, PermissionModulesEnum, PermissionActionsEnum,
  Modules,
  NonAuthRoutes
} from '../enums';
import ProtectedRoute from '../components/ProtectedRoute';
import AuditLogList from '../modules/auditLogs/list';

const AuditLogs: React.FC = () => {
  return (
    <Routes>
      {/* audit_log:view is not a seeded permission: only the system administrator passes, everyone else gets the forbidden page */}
      <Route path={RouteParamsTypes.blank} element={<ProtectedRoute component={AuditLogList} accessibleTo={[{ [PermissionModulesEnum.AuditLog]: [PermissionActionsEnum.View] }]} />} />
      <Route path={RouteParamsTypes.any} element={<Navigate replace to={{ pathname: Modules.error + NonAuthRoutes.notFound }} />} />
    </Routes>
  );
};

export default AuditLogs;
